import React from 'react'

export default function Vehicles() {
  return (
    <div>Vehicles</div>
  )
}
